export function convertEnumValue<T extends Record<string, string>>(
  fromValue: string | undefined | null,
  toEnum: T
): T[keyof T] | undefined {
  if (!fromValue) {
    return undefined
  }

  const enumValues = Object.values(toEnum)

  if (enumValues.includes(fromValue)) {
    return fromValue as T[keyof T]
  }

  return undefined
}
